module.exports = __webpack_public_path__ + "static/media/by.ba5e4290.svg";